import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import FieldLabel from '../FieldLabel';

const TextField = (props) => {
    const { label, type, isDisabled, name } = props;
    const { control } = useFormContext();

    return (
        <>
            {label && <FieldLabel label={label} name={name} />}

            <Controller
                name={name}
                control={control}
                render={({ field: { onChange, onBlur, value }, formState: { errors } }) => (
                    <input
                        id={name}
                        type={type}
                        className={`text ${errors[name] ? 'error' : ''}`}
                        autoComplete={'off'}
                        disabled={isDisabled}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={ value || ''}
                    />
                )}
            />
        </>
    );
};

TextField.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    type: PropTypes.string,
    isDisabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
};

TextField.defaultProps = {
    label: '',
    isDisabled: false,
    type: 'text',
};

export default TextField;
